const getCartFramesFromLocalStorage = () => {
  const cartFrames = localStorage?.getItem("frames");
  if (cartFrames) {
    return JSON.parse(cartFrames);
  }
  return [];
};

const getCartContactsFromLocalStorage = () => {
  const cartContacts = localStorage?.getItem("contacts");
  if (cartContacts) {
    return JSON.parse(cartContacts);
  }
  return [];
};

const initState = {
  frames: getCartFramesFromLocalStorage() || [],
  contacts: getCartContactsFromLocalStorage() || [],
  totalPrice: 0,
};

export default function cartReducer(state = initState, action: any) {
  switch (action.type) {
    case "SET_FRAMES":
      return {
        ...state,
        frames: action.data,
      };
    case "SET_CONTACTS":
      return {
        ...state,
        contacts: action.data,
      };
    case "SET_CART_TOTAL_PRICE":
      return {
        ...state,
        totalPrice: action.data,
      };
    case "RESET_CART":
      return {
        ...initState,
        totalPrice: state.totalPrice,
      };
    default:
      return state;
  }
}
